import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Badge, Flex, ItemAvatar, ItemContent, ItemDescription, TableCell, TableRow, TextBody, TextOverflowTooltip, Tooltip } from "@opensea/ui-kit";
import { ErrorFilled } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { Item } from "../Item";
import { QUOTE_RECEIPT_TABLE_COLUMN_CLASSNAMES } from "../QuoteReceipt/constants";
import { CollectionSweepQuoteReceiptFragment } from "./CollectionSweepQuoteReceipt.fragment";
import { CollectionSweepQuoteReceiptRange } from "./CollectionSweepQuoteReceiptRange";
import { getCollectionSweepQuoteError } from "./getCollectionSweepQuoteError";
export const CollectionSweepQuoteReceiptSummary = t0 => {
  const $ = _c(39);
  const {
    maxAmountOfItems,
    quote: quoteKey
  } = t0;
  const t = useTranslations("wallet.CollectionSweepQuoteReceiptSummary");
  let collection;
  let quote;
  let t1;
  if ($[0] !== quoteKey) {
    quote = readFragment(CollectionSweepQuoteReceiptFragment, quoteKey);
    collection = quote.collection;
    t1 = getCollectionSweepQuoteError(quote.quote);
    $[0] = quoteKey;
    $[1] = collection;
    $[2] = quote;
    $[3] = t1;
  } else {
    collection = $[1];
    quote = $[2];
    t1 = $[3];
  }
  const error = t1;
  let t2;
  if ($[4] !== maxAmountOfItems || $[5] !== t) {
    t2 = t("maxAmountOfItems", {
      count: maxAmountOfItems
    });
    $[4] = maxAmountOfItems;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = {
      color: "text-secondary",
      children: t2
    };
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const descriptionProps = t3;
  let t4;
  if ($[9] !== collection.imageUrl) {
    t4 = <ItemAvatar className="rounded" size={48} src={collection.imageUrl} />;
    $[9] = collection.imageUrl;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CollectionLockupContent><CollectionLockupTitle color="text-secondary" weight="regular" /></CollectionLockupContent>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== quote.collection) {
    t6 = <CollectionLockup collection={quote.collection}>{t5}</CollectionLockup>;
    $[12] = quote.collection;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== descriptionProps || $[15] !== error || $[16] !== t) {
    t7 = error ? <ItemDescription className="mt-1 whitespace-nowrap"><Tooltip align="start" content={t("quoteNotFound")}><Badge icon={ErrorFilled} variant="error">{"Unavailable"}</Badge></Tooltip></ItemDescription> : <Flex className="items-center gap-2"><TextOverflowTooltip><TextBody {...descriptionProps} /></TextOverflowTooltip></Flex>;
    $[14] = descriptionProps;
    $[15] = error;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <ItemContent>{t6}{t7}</ItemContent>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== collection.name || $[22] !== t4 || $[23] !== t8) {
    t9 = <TableCell className={QUOTE_RECEIPT_TABLE_COLUMN_CLASSNAMES.item}><Item key={collection.name} variant="unstyled">{t4}{t8}</Item></TableCell>;
    $[21] = collection.name;
    $[22] = t4;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== error || $[26] !== maxAmountOfItems || $[27] !== quote) {
    t10 = error ? null : <TableCell className={QUOTE_RECEIPT_TABLE_COLUMN_CLASSNAMES.price}><CollectionSweepQuoteReceiptRange maxAmountOfItems={maxAmountOfItems} quote={quote} /></TableCell>;
    $[25] = error;
    $[26] = maxAmountOfItems;
    $[27] = quote;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t9) {
    t11 = <TableRow>{t9}{t10}</TableRow>;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t) {
    t12 = t("substitution");
    $[32] = t;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12) {
    t13 = <Flex className="w-full flex-row"><TextBody color="text-secondary">{t12}</TextBody></Flex>;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t11 || $[37] !== t13) {
    t14 = <div>{t11}{t13}</div>;
    $[36] = t11;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
};